import { Component, ViewChild } from '@angular/core';
import { alert } from 'devextreme/ui/dialog';
import { WorkerAndToolService } from 'src/app/shared/services/worker-and-tool.service';
import { ToolbarService } from 'src/app/shared/services/toolbar.service';
import { DxDataGridComponent } from 'devextreme-angular';
import { ActivatedRoute, Router } from '@angular/router';
import { HoursOption } from 'src/app/shared/models/hours-option';
import { Registration, SelectConstructPhase, WorkerRegistration } from 'src/app/shared/models/registration';
import { ConstructionPhase } from '../../shared/models/construction-phase';
import { Worker } from 'src/app/shared/models/worker';
import { EditorPreparingEvent } from 'devextreme/ui/data_grid';
import { RegistrationWorkflowService, WorkflowContext } from '../../shared/services/registration-workflow.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-registration-phase',
    //standalone: true,
    //imports: [],
    templateUrl: './registration-phase.component.html',
    styleUrl: './registration-phase.component.scss',
    standalone: false
})
export class RegistrationPhaseComponent {

  registration!: Registration | undefined;
  option: HoursOption | any;

  forwardSubscription: any;
  backSubscription: any;

  allPhasesLocal: SelectConstructPhase[];
  //allPhasesCopy: SelectConstructPhase[];
  valid = false;

  @ViewChild(DxDataGridComponent, { static: false }) grid!: DxDataGridComponent;

  oreLavorateEditorOptions: object | undefined;
  currentWorker: Worker | undefined;

  copyWorkerReg: WorkerRegistration[] | undefined;

  private unsubscribe: Subject<void> = new Subject<void>();

  constructor(
    private service: WorkerAndToolService,
    private toolbar: ToolbarService,
    private route: ActivatedRoute,
    private router: Router,
    private workflowService: RegistrationWorkflowService) {

    this.allPhasesLocal = [];
    //this.allPhasesCopy = [];
    
    this.oreLavorateEditorOptions = {
      mode: 'number',
      showSpinButtons: false
    }
  }



  ngOnInit() {
    this.backSubscription = this.toolbar.backClickedEvent.subscribe(() => this.Back());
    this.forwardSubscription = this.toolbar.forwardClickedEvent.subscribe(() => this.Forward());

    this.service.getHoursOptionObservable().pipe(takeUntil(this.unsubscribe)).subscribe(val => {
      this.option = val;
    });

    this.toolbar.BackVisibleChanged(true);
    this.toolbar.SaveVisibleChanged(false);
    this.toolbar.ForwardVisibleChanged(true);
    this.toolbar.CancelVisibleChanged(false);
    this.toolbar.PlusVisibleChanged(false);
    this.toolbar.EditVisibleChanged(false);
    this.toolbar.DeleteVisibleChanged(false);
    this.toolbar.CopyVisibleChanged(false);
    this.toolbar.MenuVisibleChanged(false);

    let regId = this.route.snapshot.paramMap.get('id');

    if (regId == null) {
      regId = "-1";
    }

    this.copyWorkerReg = [];

    this.service.getCurrentWorker().then(val => {
      this.currentWorker = val;
    });

    this.service.getTempRegistration(Number(regId)).then((reg) => {

      this.registration = reg;
      if (this.registration) {


        const constrSite = this.registration.cantiere;
        if (constrSite) {

          this.service.getConstructionPhases(constrSite).then((s) => {
            s.forEach(x => {


              const selected = this.registration?.allSelectedPhases?.filter(f => f.constructionPhaseCode == x.constructionPhaseCode).length;
              let hours = 0;
              this.registration?.allSelectedPhases?.filter(f => {
                if (f.constructionPhaseCode == x.constructionPhaseCode) {
                  hours = f.hoursTime;
                }
              });

              this.allPhasesLocal.push({
                selected: selected == 0 ? false : true,
                constructionPhaseCode: x.constructionPhaseCode,
                constructionPhaseDescription: x.constructionPhaseDescription,
                constructionSiteCode: x.constructionSiteCode,
                hoursTime: hours
              });
            });

          });

          if (this.registration?.allPhases) {
            this.registration.allPhases = this.allPhasesLocal;
          }
        }
      }

    });
  }

  ngOnDestroy() {
    this.backSubscription?.unsubscribe();
    this.forwardSubscription?.unsubscribe();
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  onEditorPreparing(e: EditorPreparingEvent) {
    if (e.dataField === "hoursTime" && e.parentType === "dataRow") {
      e.editorOptions.onFocusIn = (function (args: { element: { querySelector: (arg0: string) => { (): any; new(): any; select: { (): void; new(): any; }; }; }; }): void {
        console.log(args.element);
        args.element.querySelector(".dx-texteditor-input").select();
      })
    }
  }


  Forward() {

    this.grid.instance.saveEditData().then(() => {
      this.valid = true;



      if (this.registration) {

        //|| this.option?.workingPhase!=2 --> è undefined quindi non posso usarlo nel controllo
        // controllo se il cantiere ha 0 fasi all' attivo
        // \__>> se è così allora lo faccio comunque procedere 
        if (this.allPhasesLocal.length <= 0 ) { 
          this.valid = true
        } else {
          // controllo normale per le fasi multiple 
          this.allPhasesLocal.filter(x => x.selected).forEach(x => {
            if (x.hoursTime <= 0) {
              this.valid = false;
            }
          })
        }


        if (this.valid) {
          this.saveRegistration()
        }
        else {
          alert("Ore non indicate in alcune fasi", "Errore");
        }
      }
    });
  }


  private saveRegistration() {
    if (this.registration) {


      let alreadyCompiledEmpty = false;
      // controllo se è una duplicazione o modifica di una registrazione senza fasi
      if (this.registration.allSelectedPhases && this.registration.allSelectedPhases.length > 0) {
        alreadyCompiledEmpty = this.registration.allSelectedPhases![0].constructionPhaseCode == this.registration.cantiere;//"000";
      }



      // clearing liste + riassegnazione 
      this.registration.allSelectedPhases = [];
      this.registration.phasesCodesArray = [];

      // filtro tutta la lista delle fasi richieste e tengo solo quelle selezionate
      this.allPhasesLocal.filter(x => x.selected).forEach(x => {

        if (this.registration?.allSelectedPhases) // tiene TUTTI i dati ( base + ore + select )
          this.registration?.allSelectedPhases.push(x);
        

        if (this.registration?.phasesCodesArray) // tiene SOLO i codici delle fasi 
          this.registration?.phasesCodesArray.push(x.constructionPhaseCode);

      });


      // se un cantiere non ha fasi da selezionare setto la registrazione come SenzaFase 
      if (this.registration.phasesCodesArray.length == 0) {
        this.registration.noPhase = true;
      } else {
        this.registration.noPhase = false;
      }


      // se non si è selezionata nessuna fase allora si resetta la registrazione dei worker reg 
      if (this.allPhasesLocal.filter(x => x.selected).length == 0 && this.registration.noPhase && !alreadyCompiledEmpty) {
        this.registration.workerRegistrations = [];
      }



      const siteManagerMode = !!this.currentWorker?.siteManagerMode;

      if (!siteManagerMode) {
        // Non-siteManager: create inline worker registrations for each phase
        if (this.registration?.workerRegistrations) {
          if (this.registration?.workerRegistrations.length > 0) {
            this.registration.workerRegistrations.forEach(x => {

              this.copyWorkerReg?.push({
                workerNumber: x.workerNumber,
                workerDescription: x.workerDescription,
                oreLavorate: x.oreLavorate,
                toolCode: null,
                phaseCode: x.phaseCode,
                phaseDescription: x.phaseDescription,
                keyIdentification: x.keyIdentification,
                cost: x.cost ?? ""
              });

            });
          }
        }

        // reset struttura dati
        this.registration.workerRegistrations = [];
        this.registration.allSelectedPhases?.forEach(phase => {

          if (this.registration?.workerRegistrations) {
            if (this.currentWorker) {

              this.registration.workerRegistrations.push({
                workerNumber: this.currentWorker?.workerNumber,
                workerDescription: this.currentWorker.surname + ' ' +this.currentWorker.name,
                oreLavorate: phase.hoursTime,
                toolCode: null,
                phaseCode: phase.constructionPhaseCode,
                phaseDescription: phase.constructionPhaseDescription,
                keyIdentification: phase.constructionPhaseCode + "" + this.currentWorker.workerNumber,
                cost: this.registration.costo
              });

            }
          }

        });

        this.copyWorkerReg?.forEach(copy => {
          if (this.registration)
            this.registration.workerRegistrations.forEach(base => {
              if (base.keyIdentification == copy.keyIdentification) {
                base.workerNumber = copy.workerNumber;
                base.workerDescription = copy.workerDescription;
                base.oreLavorate = base.oreLavorate != copy.oreLavorate ? base.oreLavorate : copy.oreLavorate;
                base.toolCode = copy.toolCode;
                base.phaseCode = copy.phaseCode;
                base.phaseDescription = copy.phaseDescription;
                base.keyIdentification = copy.keyIdentification;
                base.cost = copy.cost;
              }
          });

        });
      }

      const ctx: WorkflowContext = { options: this.option, siteManagerMode, hasControls: false };
      const nextStep = this.workflowService.getNextStep('registration-phase', ctx);

      this.service.editTempRegistration(this.registration, this.registration.id ?? 0).then((regId) => this.router.navigate(['/' + nextStep, { id: regId }]));
    }
    else {
      alert("Nessuna registrazione individuata", "Errore");
    }
  }

  Back() {
    this.router.navigate(['/registration', { id: this.registration?.id }]);
  }

  verificaOreNegative(e: { value: number; }) {
    return e.value >= 0;
  }

  resetCellHours(newData: any, value: boolean, currentRowData: any) {
    // quando si preme il pulsante di selezione AZZERA SEMPRE il campo delle ore indicate

    currentRowData.hoursTime = 0;    // per visualizzare a schermo il cambiamento 
    currentRowData.selected = value; // per visualizzare a schermo il cambiamento 
    newData.hoursTime = 0;           // per cambiarlo nella struttura dati 
    newData.selected = value;        // per cambiarlo nella struttura dati
  }
}
